<template>
  <v-app>
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style>
/* One background and font for every page, so nothing flashes white
   while a page loads. */
html,
body,
#app,
.v-application {
  background: #0D2226 !important;
}

.v-application {
  font-family: 'Figtree', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif !important;
  color: #F7F0E6;
}

/* Vuetify dark surfaces in the site's colors */
.theme--dark.v-card,
.theme--dark.v-sheet,
.theme--dark.v-list,
.theme--dark.v-picker__body,
.theme--dark.v-date-picker-table {
  background-color: #122D32;
}

.theme--dark.v-overlay {
  background-color: rgba(4, 14, 16, 0.72) !important;
}

::selection {
  background: rgba(244, 162, 89, 0.35);
  color: #F7F0E6;
}

/* Thin dark scrollbars */
* {
  scrollbar-color: #24454B #0D2226;
}

::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-track {
  background: #0D2226;
}

::-webkit-scrollbar-thumb {
  background: #24454B;
  border-radius: 10px;
  border: 2px solid #0D2226;
}

::-webkit-scrollbar-thumb:hover {
  background: #2E5258;
}
</style>
